import { Injectable, isDevMode } from '@angular/core';
import { Http, Response } from '@angular/http';
import { IAppConfig } from './models/appConfig';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {

  static settings: IAppConfig;

  constructor(private http: Http) { }

  load() {
    return new Promise<void>((resolve, reject) => {
      AppConfig.settings = environment;
      resolve();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts